/* eslint-disable */
import React from "react";
import * as MUI from "@material-ui/core";
import { useStyles } from "./styles";
import { Link } from "react-router-dom";
import cn from "classnames";

export const BlockCard = ({ children, to, disabled = false, ...props }) => {
  const nodeWithblockIndex = children.find((node) => node.props.blockIndex);
  const classes = useStyles(props);

  let backroundColor = "#004A96";
  switch (nodeWithblockIndex.props.blockIndex) {
    case 2:
      backroundColor = `#21A0D2`;
      break;
    case 3:
      backroundColor = `#00793A`;
      break;
    case 4:
      backroundColor = `#65AC1E`;
      break;
  }

  return (
    <MUI.Card
      className={cn(classes.card, {
        [classes.cardHoverBoxShadow]: !disabled,
      })}
      role={props.role}
    >
      {disabled ? (
        <div className={classes.disabledBlock}>
          <MUI.CardContent
            className={cn(classes.content, classes.disabledContent)}
            style={{ backgroundColor: backroundColor }}
          >
            <div className={classes.contentRoot}>{children}</div>
          </MUI.CardContent>
        </div>
      ) : (
        <Link className={classes.link} to={to}>
          <MUI.CardContent className={classes.content} style={{ backgroundColor: backroundColor }}>
            <div className={classes.contentRoot}>{children}</div>
          </MUI.CardContent>
        </Link>
      )}
    </MUI.Card>
  );
};
BlockCard.muiName = "BlockCard";
BlockCard.displayName = "BlockCard";
BlockCard.defaultProps = {
  role: "blockCard",
};
export default BlockCard;

export * from "./BlockCardDescription";
export * from "./BlockCardImg";
